import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="px-4 md:px-8 lg:px-12 py-10 md:py-14">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div className="flex items-center gap-3">
            <img
              src="/images/logo_b.png"
              alt="신가영 법률사무소  로고"
              className="h-8 w-auto"
            />
            <div>
              <p className="font-heading text-base font-bold text-foreground-950">
                신가영 법률사무소
              </p>
              <p className="text-xs text-foreground-500 mt-0.5">
                {t('footer.keyword')} | 대전 서구 둔산중로78번길 26 민석타워 606호
              </p>
            </div>
          </div>

          <div className="flex flex-wrap items-center gap-4 md:gap-6">
            <a
              href="tel:042-721-0105"
              className="text-sm text-foreground-600 hover:text-primary-500 transition-colors flex items-center gap-1.5"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-line text-xs"></i>
              </span>
              042-721-0105
            </a>
            <a
              href="tel:010-2833-1395"
              className="text-sm text-foreground-600 hover:text-primary-500 transition-colors flex items-center gap-1.5"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-smartphone-line text-xs"></i>
              </span>
              010-2833-1395
            </a>
            <a
              href="https://blog.naver.com/ant1301"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="text-sm text-foreground-600 hover:text-primary-500 transition-colors flex items-center gap-1.5"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-global-line text-xs"></i>
              </span>
              블로그
            </a>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            {t('footer.copyright')}
          </p>
          <p className="text-xs text-foreground-400">
            {t('footer.keyword')} 신가영 변호사
          </p>
        </div>
      </div>
    </footer>
  );
}